import { Link } from "@ds/react";
import Form from "components/Form";
import ResponsiveCard from "components/ResponsiveCard";
import Section from "components/Section";
import useCep from "hooks/useCep";
import useUfs from "hooks/useUfs";
import { useState, useRef, useEffect } from "react"; // <-- Importamos useRef e useEffect
import masks from "utils/form/masks";
import { required } from "utils/form/validations";

const parseAddressData = (addressData) => ({
  endereco: addressData.descricao,
  numero: "",
  complemento: "",
  bairro: addressData.bairro?.substring(0, 30),
  cidade: addressData.localidade,
  uf: { id: addressData.uf, value: addressData.uf },
});

const DadosEndereco = ({ validationRef, initialValue }) => {
  const { ufs, loading: loadingUfs } = useUfs();
  const { loading, getCep } = useCep();
  const [address, setAddress] = useState(
    initialValue?.dadosComplementares?.uf?.id
      ? initialValue?.dadosComplementares
      : undefined
  );

  const addressRef = useRef(address);
  useEffect(() => {
    addressRef.current = address;
  }, [address]);

  const validateCep = () => {
    return createResult(!!addressRef.current, "Informe um CEP válido");
  };

  const handleCepChange = async (cep) => {
    setAddress(undefined);
    
    if (cep.length === 8) {
      const { data, type } = await getCep(cep);
      
      if (type === "error" || data.codigo_retorno !== 0) {
        validationRef.current.updateField("cep", {
          value: cep, 
          errorMessage: "Informe um CEP válido", 
        });
      } else {
        setAddress(parseAddressData(data));
        validationRef.current.updateField("cep", {
          value: cep, 
          errorMessage: "", 
        });
      }
    }
  };

  return (
    <section>
      <Section>
        <ResponsiveCard maxContent title="Endereço">
          <Form.Section validationRef={validationRef} scheme={initialValue}>
            <Form.Input
              name="cep"
              label="CEP"
              placeholder="Apenas números"
              loading={loading}
              validationRules={[
                required,
                validateCep, 
              ]}
              optionalLabel={
                <Link
                  role="button"
                  variant="primary-sm-02"
                  href="https://buscacepinter.correios.com.br/app/endereco/index.php"
                  target="_blank"
                >
                  {"Não sei meu CEP"}
                </Link>
              }
              onChange={handleCepChange}
              half
              mask={masks.cep}
            />
            {address && (
              <Form.Section scheme={address} name="dadosComplementares">
                <Form.Input
                  name="endereco"
                  label="Endereço"
                  validationRules={[required]}
                  mask={masks.maxLength(56)}
                />
                <Form.Input
                  name="numero"
                  label="Número"
                  validationRules={[required]}
                  half
                />
                <Form.Input name="complemento" label="Complemento" />
                <Form.Input
                  name="bairro"
                  label="Bairro"
                  validationRules={[required]}
                  half
                  mask={masks.maxLength(30)}
                />
                <Form.Input
                  name="cidade"
                  label="Cidade"
                  validationRules={[required]}
                  half
                  mask={masks.maxLength(30)}
                />
                <Form.InputSelect
                  name="uf"
                  label="UF"
                  options={ufs}
                  validationRules={[required]}
                  width="25%"
                  loading={loadingUfs}
                  selectOnly
                  noMinWidth
                />
              </Form.Section>
            )}
          </Form.Section>
        </ResponsiveCard>
      </Section>
    </section>
  );
};

export default DadosEndereco;

// Função auxiliar 
const createResult = (isValid, errorMessage) => ({
  isValid,
  errorMessage: isValid ? "" : errorMessage,
});